const basetTestingId = 'global-location-picker';

export const LocationPickerTestingIds = {
  groupOption: (label: string) => `${basetTestingId}-${label}-group-option`,
  groupRadio: (label: string) => `${basetTestingId}-${label}-group-radio`,
  groupSearchRadio: (label: string) => `${basetTestingId}-${label}-group-search-radio`,
  groupSearchOption: (label: string) => `${basetTestingId}-${label}-group-search-option`,
  searchButton: `${basetTestingId}-search-button`,
};
